import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FaPlus } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import LoadingComponent from './../../widgets/LoadingComponent';
import { getData } from './../../api/ApiRest'
import Form from 'react-bootstrap/Form';
import { updateEmpresaCertificado } from './EmpresaApi'
import { formatDateddMMyyyyhhmm } from './../../widgets/DateTime'


///https://www.browserling.com/tools/file-to-base64
function EmpresaCertificadoCrud({ Show, Nuevo = false, cerrarModal, CompanySelect, Es_Cliente }) {
    const [loading, setLoading] = useState(false);
    const [certificates, setCertificates] = useState([]);
    const [certificadoNuevo, setcertificadoNuevo] = useState({ certificate: '', password: '' });
    const [nuevo, setNuevo] = useState(Nuevo);

    const initForm = () => {
        setcertificadoNuevo({ certificate: '', password: '' });
        setNuevo(false);
        setCertificates([]);
        setLoading(true);

        getData('api/Configuracion/Company/CertificateGetData', { Companyid: CompanySelect.id },
            false).then(response => {

                if (response.status === true) {
                    setCertificates(response.certificates);
                }

                setLoading(false);
            }, error => {
                console.log(error);
                setLoading(false);
                alert('Algo salio mal al cargar el formulario');
            })
    }


    const ButtonNuevo = () => {
        if (nuevo === false && Es_Cliente === 'true')
            return <Button type='button' onClick={() => setNuevo(true)}
                size='sm' variant='success' title='Nuevo Certificado'>
                <FaPlus size={'1rem'} />
            </Button>
    }


    const NuevoForm = () => {
        if (nuevo === true) {
            return <form onSubmit={nuevoCertificado}>
                <div className='row'>
                    <div className='col-md-8'>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Certificado</Form.Label>
                            <Form.Control
                                size='sm'
                                as="textarea"
                                autoComplete='off'
                                required={true}
                                rows={15}
                                value={certificadoNuevo.certificate}
                                onChange={value => {
                                    setcertificadoNuevo({ ...certificadoNuevo, certificate: value.target.value })
                                }}
                            />
                            <button type='button' className='btn btn-sm btn-secondary' onClick={() => {
                                window.open('https://www.browserling.com/tools/file-to-base64', '_blank');
                            }}>Codificiar</button>
                        </Form.Group>
                    </div>

                    <div className='col-md-4'>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Contraseña</Form.Label>
                            <Form.Control
                                size='sm'
                                autoComplete='off'
                                as="input"
                                required={true}
                                value={certificadoNuevo.password}
                                onChange={value => {
                                    setcertificadoNuevo({ ...certificadoNuevo, password: value.target.value })
                                }}
                            />
                        </Form.Group>

                        <Button type='submit' className='m-3' variant='success'>
                            Guardar
                        </Button>

                        <Button type='button' className='m-3' variant='danger' onClick={() => setNuevo(false)}>
                            Cancelar
                        </Button>
                    </div>



                </div>
            </form>
        }
    }


    const nuevoCertificado = (event) => {
        setLoading(true);
        event.preventDefault();

        updateEmpresaCertificado(certificadoNuevo.certificate, certificadoNuevo.password,
            CompanySelect.user_Api_Token).then(response => {
                alert(response.message);
                if (response.success === true) {
                    cerrarModal(true);
                }
                setLoading(false);
            }, error => {
                console.log(error, 'error');
                setLoading(false);
            })

        setTimeout(() => {
            activaPlanReserva();
        }, 2000);

    }

    ///Función para activar un plan que se encuentre en reserva
    const activaPlanReserva = () => {
        getData('api/Configuracion/Factura/validarPlanesReserva', {
            companyId: CompanySelect.id,
            es_certificado: true
        }).then(response => {
            if (response.status)
                alert(response.msj);
        }, error => {
            console.log(error);
        })
    }


    return <Modal
        size='xl'
        show={Show}
        onShow={initForm}
        onHide={cerrarModal}>
        <Modal.Header closeButton>
            <Modal.Title>CERTIFICADO  DE {CompanySelect.empresa_Nombre}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {<LoadingComponent Loading={loading} />}

            {ButtonNuevo()}

            {NuevoForm()}

            <div className='table-responsive mt-2'>
                <table className='table table-sm table-bordered table-hover'>
                    <thead>
                        <tr>
                            <th>
                                Nombre
                            </th>
                            <th>
                                Contraseña
                            </th>
                            <th>
                                Vencimiento
                            </th>
                            <th>
                                Creacion
                            </th>
                            <th>
                                Ult Act
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {certificates.map((item, key) => (
                            <tr key={key}>
                                <td>
                                    {item.name}
                                </td>
                                <td>
                                    {item.Password}
                                </td>
                                <td className='text-center'>
                                    {formatDateddMMyyyyhhmm(item.expirationDate)}
                                </td>
                                <td className='text-center'>
                                    {formatDateddMMyyyyhhmm(item.created)}
                                </td>
                                <td className='text-center'>
                                    {formatDateddMMyyyyhhmm(item.lastUpdated)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>


        </Modal.Body>
    </Modal>

}

export default EmpresaCertificadoCrud;
